import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPWithdrawRequestActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/WithdrawRequest/WithdrawRequestBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceAPWithdrawRequest"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPWithdrawRequest"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPWithdrawRequestActivity)
